export interface ContentProgress {
  type:
    | 'text'
    | 'video'
    | 'objective-exercise'
    | 'discursive-exercise'
    | 'practice-exercise'
    | 'objective-trivia';
  courseId: string;
  subModuleId: string;
  disciplineId: string;
  disciplineVersionId?: string;
  lessonId: string;
  discursiveExerciseId?: string;
  practiceExerciseId?: string;
  objectiveExerciseId?: string;
  objectiveTriviaId?: string;
  textId?: string;
  videoId?: string;
  percentage: number;
  moment?: string;
  consumptionMoment?: string;
}

export interface ContinueStudying {
  disciplineInstanceId: string;
  lessonId: string;
}

export interface ProgressMap {
  [key: string]: number;
}

export interface MomentMap {
  [key: string]: Date | undefined;
}

export interface UndergradProgressState {
  loading: boolean;
  outdated: boolean;
  continueStudying: ContinueStudying[];
  courses: ProgressMap;
  modules: ProgressMap;
  disciplines: ProgressMap;
  lessons: ProgressMap;
  contents: ProgressMap;
  moments: MomentMap;
}

const state: UndergradProgressState = {
  loading: true,
  outdated: true,
  continueStudying: [],
  courses: {},
  modules: {},
  disciplines: {},
  lessons: {},
  contents: {},
  moments: {},
};

export default state;
